import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  showErrorToastMessage,
  showSuccessToastMessage,
} from "../../../component/Toasts/Toasts";
import * as actions from "../../../Redux/Actions/index";
import "./ResourceMaster.scss";
import {
  isCharactersValid,
  employeeEmailIdValidation,
  employeeMobileNumberValidtion,
} from "../../../constant/Validations";
import { timeDateFormatYMD } from "../../../component/FormatDate";

function AddInseedResource(props: any) {
  const {
    hideAddModal,
    apiCallCompleted,
    inseedBatchStartDate,
    setInseedBatchStartDate,
  } = props;
  const [btnDisable, setBtnDisable] = useState(false);
  const [inseedResourceData, setinseedResourceData] = useState<any>({
    employeeRef: "",
    inseedBatchRef: "",
    selectedStatus: "",
    resourceName: "",
    startDate: "",
    endDate: "",
    degreeCertificate: null,
    bondLetter: null,
    offerLetter: null,
    contactNumber: "",
    personalEmail: "",
    emergencyContact: "",
    dateOfOnBoarding: "",
  });
  const [errors, setErrors] = useState({
    employeeRef: "",
    inseedBatchRef: "",
    selectedStatus: "",
    resourceName: "",
    startDate: "",
    endDate: "",
    contactNumber: "",
    personalEmail: "",
    emergencyContact: "",
    dateOfOnBoarding: "",
  });

  const {
    employeeRef,
    inseedBatchRef,
    selectedStatus,
    resourceName,
    startDate,
    endDate,
    degreeCertificate,
    bondLetter,
    offerLetter,
    contactNumber,
    personalEmail,
    emergencyContact,
    dateOfOnBoarding,
  } = inseedResourceData;

  const [docFile, setDocFile] = useState<any>({
    degreeCertificate: null,
    bondLetter: null,
    offerLetter: null,
  });

  const [employeeInfo, setEmployeeInfo] = useState([]);
  const [inseedBatch, setinseedBatch] = useState<any>([]);

  const dispatch = useDispatch();
  useEffect(() => {
    if (
      inseedBatchRef &&
      resourceName &&
      startDate &&
      endDate &&
      degreeCertificate &&
      bondLetter &&
      offerLetter &&
      personalEmail &&
      contactNumber
    ) {
      setBtnDisable(true);
    } else {
      setBtnDisable(false);
    }
  });
  let valid: boolean = true;
  const validate = () => {
    if (contactNumber) {
      if (employeeMobileNumberValidtion(contactNumber) == false) {
        valid = false;
        setErrors((errorObj) => ({
          ...errorObj,
          contactNumber: "Enter a vaild Contact Number",
        }));
        setBtnDisable(false);
      } else {
        setErrors((errorObj) => ({
          ...errorObj,
          contactNumber: "",
        }));
      }
    }
    if (emergencyContact) {
      if (employeeMobileNumberValidtion(emergencyContact) == false) {
        valid = false;
        setErrors((errorObj) => ({
          ...errorObj,
          emergencyContact: "Enter a vaild Contact Number",
        }));
        setBtnDisable(false);
      } else {
        setErrors((errorObj) => ({
          ...errorObj,
          emergencyContact: "",
        }));
      }
    }
    if (inseedBatchRef.length == 0 && selectedStatus.length == 0) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        inseedBatchRef: "Batch Name is a required feild",
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, inseedBatchRef: "" }));
    }
    if (resourceName.length == 0) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        resourceName: "Trainee Name is a required feild",
      }));
      setBtnDisable(false);
    }
    if (isCharactersValid(resourceName) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        resourceName: "Enter a vaild Trainee Name",
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({
        ...errorObj,
        resourceName: "",
      }));
    }
    if (startDate.length == 0) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        startDate: "This is a required feild",
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, startDate: "" }));
    }
    if (endDate.length == 0) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        endDate: "This is a required feild",
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, endDate: "" }));
    }

    if (personalEmail) {
      if (
        (employeeEmailIdValidation(personalEmail) == false &&
          personalEmail?.includes("gmail.com")) ||
        personalEmail?.includes("yahoo.com") ||
        personalEmail?.includes("hotmail.com") ||
        personalEmail?.includes("rediffmail.com") ||
        personalEmail?.includes("live.in") ||
        personalEmail?.includes("outlook.com")
      ) {
        valid = false;
        setErrors((errorObj) => ({
          ...errorObj,
          personalEmail: "Enter a vaild Email Address",
        }));
        setBtnDisable(false);
      } else {
        setErrors((errorObj) => ({
          ...errorObj,
          personalEmail: "",
        }));
      }
    }
  };
  const handleSubmit = () => {
    validate();
    if (valid) {
      handleDispatch();
      hideAddModal();
    }
  };
  const handleDispatch = () => {
    apiCallCompleted(false);
    dispatch(
      actions.addInseedResourceAction(
        {
          employeeRef: employeeRef,
          inseedBatchRef: inseedBatchRef,
          startDate: startDate,
          endDate: endDate,
          degreeCertificate: degreeCertificate,
          bondLetter: bondLetter,
          offerLetter: offerLetter,
          contactNumber: contactNumber,
          personalEmail: personalEmail,
          emergencyContact: emergencyContact,
          dateOfOnBoarding: dateOfOnBoarding,
          resourceName: resourceName,
        },
        (res: any) => {
              if (res?.error?.error_description) {
                showErrorToastMessage(res.error.error_description);
                apiCallCompleted(true);
              } else if (res.code === 200) {
                showSuccessToastMessage("Added successfully!");
                apiCallCompleted(true);
          }
        }
      )
    );
  };
  useEffect(() => {
    dispatch(actions.getEmployeeDataAction((res: any) => {}));
  }, []);

  const employeeData = useSelector(
    (state: any) => state.employeeReducer.getEmployeeData
  );

  useEffect(() => {
    if (employeeData && employeeData.data) {
      setEmployeeInfo(employeeData.data);
    }
  }, [employeeData, employeeInfo]);

  const handleSubmitdegreeCertificate = (e: any) => {
    const file = e.target.files[0];
    const fileName = file.name;
    if ((fileName.match(/\./g) || []).length > 1) {
      showErrorToastMessage("Invalid filename. Double extensions are not allowed.");
      e.target.value = null;
      return;
    }
    const fileSize = file.size;
    const fileType = file.type;
    if (fileSize > 2 * 1024 * 1024) {
      showErrorToastMessage("File size too large. Maximum size is 2 MB.");
      return;
    } else if (
      !["image/jpeg", "image/png", "application/pdf"].includes(fileType)
    ) {
      showErrorToastMessage(
        "File type not allowed. Allowed types are JPEG, PNG, and PDF."
      );
      return;
    } else {
      setDocFile({ ...docFile, degreeCertificate: e.target.files[0] });
      dispatch(
        actions.inseedDocUploadAction(
          { file: e.target.files[0] },
          (res: any) => {
            if (res.code == 200 && res.data) {
              setinseedResourceData({
                ...inseedResourceData,
                degreeCertificate: res.data,
              });
            }
          }
        )
      );
    }
  };

  const handleSubmitbondLetter = (e: any) => {
    const file = e.target.files[0];
    const fileName = file.name;
    if ((fileName.match(/\./g) || []).length > 1) {
      showErrorToastMessage("Invalid filename. Double extensions are not allowed.");
      e.target.value = null;
      return;
    }
    const fileSize = file.size;
    const fileType = file.type;
    if (fileSize > 2 * 1024 * 1024) {
      showErrorToastMessage("File size too large. Maximum size is 2 MB.");
      return;
    } else if (
      !["image/jpeg", "image/png", "application/pdf"].includes(fileType)
    ) {
      showErrorToastMessage(
        "File type not allowed. Allowed types are JPEG, PNG, and PDF."
      );
      return;
    } else {
      setDocFile({ ...docFile, bondLetter: e.target.files[0] });
      dispatch(
        actions.inseedDocUploadAction(
          { file: e.target.files[0] },
          (res: any) => {
            if (res.code == 200 && res.data) {
              setinseedResourceData({
                ...inseedResourceData,
                bondLetter: res.data,
              });
            }
          }
        )
      );
    }
  };

  const handleSubmitofferLetter = (e: any) => {
    const file = e.target.files[0];
    const fileName = file.name;
    if ((fileName.match(/\./g) || []).length > 1) {
      showErrorToastMessage("Invalid filename. Double extensions are not allowed.");
      e.target.value = null;
      return;
    }
    const fileSize = file.size;
    const fileType = file.type;
    if (fileSize > 2 * 1024 * 1024) {
      showErrorToastMessage("File size too large. Maximum size is 2 MB.");
      return;
    } else if (
      !["image/jpeg", "image/png", "application/pdf"].includes(fileType)
    ) {
      showErrorToastMessage(
        "File type not allowed. Allowed types are JPEG, PNG, and PDF."
      );
      return;
    } else {
      setDocFile({ ...docFile, offerLetter: e.target.files[0] });

      dispatch(
        actions.inseedDocUploadAction(
          { file: e.target.files[0] },
          (res: any) => {
            if (res.code == 200 && res.data) {
              setinseedResourceData({
                ...inseedResourceData,
                offerLetter: res.data,
              });
            }
          }
        )
      );
    }
  };
  useEffect(() => {
    dispatch(
      actions.getApprovedInseedDataAction(
        "",
        "",
        "",
        "",
        "notCompleted",
        (res: any) => { 
          if (res?.error?.error_description) {
                showErrorToastMessage(res.error.error_description);
          } else if (res.code === 200) {
                setinseedBatch(res.data);
          }
        }
      )
    );
  }, []);
  return (
    <>
      <div className="row g-3">
        <div className="col-md-4 ">
          <label className="form-label ">Batch Name</label>
          <span className="required">*</span>
          <Dropdown
            onSelect={(eventKey: any) => {
              const selectedBatch = inseedBatch.find(
                (obj: any) => obj._id == eventKey.split("&")[1]
              );
              setinseedResourceData({
                ...inseedResourceData,
                inseedBatchRef: eventKey.split("&")[1],
                selectedStatus: eventKey.split("&")[0],
              });
              setInseedBatchStartDate(selectedBatch.startDate);
            }}
          >
            <Dropdown.Toggle variant="light" className="form-control col">
              {selectedStatus}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {inseedBatch?.length > 0 &&
                inseedBatch?.map((ele: any) => (
                  <Dropdown.Item
                    eventKey={ele.inseedBatch + "&" + ele._id}
                    key={ele._id}
                  >
                    {ele.inseedBatch}
                  </Dropdown.Item>
                ))}
            </Dropdown.Menu>
          </Dropdown>
          <p className="error">{errors.inseedBatchRef}</p>
        </div>
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            Trainee Name
          </label>
          <span className="required">*</span>

          <input
            type="text"
            className="form-control"
            onChange={(e) =>
              setinseedResourceData({
                ...inseedResourceData,
                resourceName: e.target.value,
              })
            }
          />
          <p className="error">{errors.resourceName}</p>
        </div>
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            DOJ-INSEED
          </label>
          <span className="required">*</span>
          <input
            min={timeDateFormatYMD(inseedBatchStartDate)}
            type="date"
            className="form-control"
            value={startDate}
            onChange={(e) =>
              setinseedResourceData({
                ...inseedResourceData,
                startDate: e.target.value,
              })
            }
          />
          <p className="error">{errors.startDate}</p>
        </div>
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            LWD-INSEED
          </label>
          <span className="required">*</span>

          <input
            min={
              timeDateFormatYMD(startDate) ||
              timeDateFormatYMD(inseedBatchStartDate)
            }
            type="date"
            className="form-control"
            maxLength={10}
            value={endDate}
            onChange={(e) =>
              setinseedResourceData({
                ...inseedResourceData,
                endDate: e.target.value,
              })
            }
          />
          <p className="error">{errors.endDate}</p>
        </div>
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            Personal Email
          </label>
          <span className="required">*</span>
          <input
            type="email"
            className="form-control"
            onChange={(e) =>
              setinseedResourceData({
                ...inseedResourceData,
                personalEmail: e.target.value,
              })
            }
          />
          <p className="error">{errors.personalEmail}</p>
        </div>
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            Contact Number
          </label>
          <span className="required">*</span>
          <input
            type="text"
            className="form-control"
            maxLength={15}
            onChange={(e) =>
              setinseedResourceData({
                ...inseedResourceData,
                contactNumber: e.target.value,
              })
            }
          />
          <p className="error">{errors.contactNumber}</p>
        </div>

        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            Emergency Contact Number
          </label>

          <input
            type="text"
            maxLength={15}
            className="form-control"
            onChange={(e) =>
              setinseedResourceData({
                ...inseedResourceData,
                emergencyContact: e.target.value,
              })
            }
          />
          <p className="error">{errors.emergencyContact}</p>
        </div>
        <div className="col-md-4">
          <label htmlFor="inputName4" className="form-label">
            On Boarding Date
          </label>
          <input
            min={new Date().toISOString().split("T")[0]}
            type="date"
            className="form-control"
            value={dateOfOnBoarding}
            onChange={(e) =>
              setinseedResourceData({
                ...inseedResourceData,
                dateOfOnBoarding: e.target.value,
              })
            }
          />
          <p className="error">{errors.dateOfOnBoarding}</p>
        </div>
        <div className="row g-3">
          <div className="col-md-4">
            <label className="form-label">
              Upload Certificate <span className="required">*</span>
            </label>

            <div>
              <input
                type="file"
                className="form-control"
                onChange={handleSubmitdegreeCertificate}
                hidden
                id="actual-btn-1"
              />
              <label
                htmlFor="actual-btn-1"
                className="btn btn-outline-secondary buttonsize"
              >
                Upload File
              </label>
            </div>
            <p className="image-size-condition">Image/File size (Max 2MB)</p>
            <a
              href={degreeCertificate?.document_path_url}
              target="_blank"
              className="buttonsize"
            >
              {degreeCertificate?.document_path_url ? "View File" : ""}
            </a>
            <p className="image-size-condition">
              {docFile.degreeCertificate?.name}
            </p>
          </div>

          <div className="col-md-4">
            <label className="form-label">
              Upload Agreement Letter <span className="required">*</span>
            </label>
            <div>
              <input
                type="file"
                className="form-control"
                onChange={handleSubmitbondLetter}
                hidden
                id="actual-btn-3"
              />
              <label
                htmlFor="actual-btn-3"
                className="btn btn-outline-secondary buttonsize"
              >
                Upload File
              </label>
            </div>
            <p className="image-size-condition">Image/File size (Max 2MB)</p>
            <a
              href={bondLetter?.document_path_url}
              target="_blank"
              className="buttonsize"
            >
              {bondLetter?.document_path_url ? "View File" : ""}
            </a>
            <p className="image-size-condition">{docFile.bondLetter?.name}</p>
          </div>
          <div className="col-md-4">
            <label className="form-label">
              Upload Offer Letter <span className="required">*</span>
            </label>
            <div>
              <input
                type="file"
                className="form-control"
                onChange={handleSubmitofferLetter}
                hidden
                id="actual-btn-4"
              />
              <label
                htmlFor="actual-btn-4"
                className="btn btn-outline-secondary buttonsize"
              >
                Upload File
              </label>
            </div>
            <p className="image-size-condition">Image/File size (Max 2MB)</p>
            <a
              href={offerLetter?.document_path_url}
              target="_blank"
              className="buttonsize"
            >
              {offerLetter?.document_path_url ? "View File" : ""}
            </a>
            <p className="image-size-condition">{docFile.offerLetter?.name}</p>
          </div>
        </div>
        <div className="modal-btn-wrapper mt-4 mb-4">
          <div>
            <button
              className="btn cancel-btn buttonsize"
              onClick={hideAddModal}
            >
              Cancel
            </button>
          </div>
          <div>
            <button
              className={
                btnDisable
                  ? "btn add-submit-button buttonsize"
                  : "btn add-submit-button btn-disabled buttonsize"
              }
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddInseedResource;
